'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty = require('babel-runtime/core-js/object/define-property');

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _setImmediate2 = require('babel-runtime/core-js/set-immediate');

var _setImmediate3 = _interopRequireDefault(_setImmediate2);

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _IrcClient = require('../IrcClient');

var IrcClient = _interopRequireWildcard(_IrcClient);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NetworkState = function () {
    function NetworkState(id, appState, userDict, bufferDict) {
        var _this = this;

        (0, _classCallCheck3.default)(this, NetworkState);

        this.id = id;
        this.name = '';

        this.state = 'disconnected';
        this.state_error = '';

        this.last_error = '';
        this.auto_commands = '';
        this.is_znc = false;
        this.channel_list = [];
        this.channel_list_state = '';
        this.connection = {
            server: '',
            port: 6667,
            tls: false,
            path: '',
            password: '',
            direct: false,
            encoding: 'utf8',
            bncname: ''
        };
        this.settings = {};
        this.nick = '';
        this.username = '';
        this.gecos = '';
        this.password = '';

        def(this, 'appState', appState, false);
        def(this, 'userDict', userDict, false);
        def(this, 'bufferDict', bufferDict, false);
        def(this, 'ircClient', IrcClient.create(appState, this), true);

        def(this, 'users', (0, _create2.default)(null), function (newVal) {
            appState.$set(userDict.networks, _this.id, newVal);
        });

        bufferDict.$set(bufferDict.networks, this.id, []);
    }

    (0, _createClass3.default)(NetworkState, [{
        key: 'connect',
        value: function connect() {
            var _ircClient;

            (_ircClient = this.ircClient).connect.apply(_ircClient, arguments);
        }
    }, {
        key: 'bufferByName',
        value: function bufferByName(name) {
            return this.appState.getBufferByName(this.id, name);
        }
    }, {
        key: 'serverBuffer',
        value: function serverBuffer() {
            return this.appState.getBufferByName(this.id, '*');
        }
    }, {
        key: 'setting',
        value: function setting(name, val) {
            if (typeof val !== 'undefined') {
                this.appState.$set(this.settings, name, val);
                return val;
            }

            return this.settings[name];
        }
    }, {
        key: 'isChannelName',
        value: function isChannelName(input) {
            if (typeof input !== 'string' || !input) {
                return false;
            }

            var chanPrefixes = this.ircClient.network.supports('CHANTYPES') || '#&';
            return chanPrefixes.indexOf(input[0]) > -1;
        }
    }, {
        key: 'showServerBuffer',
        value: function showServerBuffer(tabName) {
            var _this2 = this;

            this.appState.$emit('active.component', null);
            this.appState.setActiveBuffer(this.id, this.serverBuffer().name);

            (0, _setImmediate3.default)(function () {
                _this2.appState.$emit('server.tab.show', tabName || 'settings');
            });
        }
    }, {
        key: 'buffers',
        get: function get() {
            return this.bufferDict.networks[this.id];
        }
    }]);
    return NetworkState;
}();

exports.default = NetworkState;

function def(target, key, value, canSet) {
    var val = value;

    var definition = {
        get: function get() {
            return val;
        }
    };

    if (canSet) {
        definition.set = function set(newVal) {
            var oldVal = val;
            val = newVal;
            if (typeof canSet === 'function') {
                canSet(newVal, oldVal);
            }
        };
    }

    (0, _defineProperty2.default)(target, key, definition);

    if (typeof canSet === 'function') {
        canSet(val);
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/libs/state/NetworkState.js
// module id = ox6C
// module chunks = 1